import Loadable from 'react-loadable'
import React from 'react'
import Loading from '../components/Loading/Global'

const LoadableAccount = Loadable({
	loader  : () => import('../containers/Account/index'),
	loading : () => <Loading />
})

const LoadableNsi = Loadable({
	loader  : () => import('../containers/NRI/index'),
	loading : () => <Loading />
})

const LoadableNsiModify = Loadable({
	loader  : () => import('../containers/NRI/nriModify/index'),
	loading : () => <Loading />
})

export const accountLoadables = {
	LoadableAccount,
	LoadableNsi,
	LoadableNsiModify
}
